module.exports = __webpack_public_path__ + "img/img_案例09.63676df2.png";